export default __webpack_public_path__ + "static/media/muft.13814217.png";